/* eslint-disable complexity */
import { DEFAULT_ADDRESS, ADDRESS_FORM_MODE, REG_FORM_MODE } from './Shipping/Shipping.constants';
import {
  SECTION_MODE,
  SPC_SECTION,
  TOGGLE_SPC,
  UPDATE_SECTION_STATE,
  UPDATE_MULTIPLE_SECTION_STATES,
  CARD_TYPES,
  SET_CVV_MODULE_X,
  SET_GIFT_DETAIL_MODAL_MODULE_X,
  SET_CVV_VISIBILITY_ON_VIEW_MODE,
  SET_SPC_BTN_LOADER,
  SPC_BUTTON,
  RESET_SPC_UI_STATE,
  SET_SECTION_ANCHORING,
  SHOW_ADDRESS_VERIFICATION,
  UPDATE_SUBMIT_ORDER_BUTTON_STATE,
  SUBMIT_ORDER_BUTTON_STATE,
  SET_SFS_ERROR,
  MOVE_ITEM_TO_SFL_TOGGLE,
  REMOVE_ITEM_IN_PROGRESS,
  CLICKED_OUTSIDE_SHIPPING,
  IS_EXPRESS_CALL_DONE,
  IS_NON_CACHED_CART_DATA_CALL_DONE,
  TRIGGER_CHECKOUT_WITH_PAYMENT,
  IS_EXTENDED_PRE_ORDER,
  SHOW_SHIPPING_METHODS_IN_COLLAPSED,
  SET_IS_OOS_ITEM,
  SET_APPLE_WALLET,
  TOGGLE_VERIFY_CVV_MODAL,
  SET_SUPPRESS_CCHECK,
  SHOULD_SHOW_VERIFY_CVV_MODAL,
} from './SinglePageCheckout.constants';

export const INIT_STATE = {
  isSPC: false,
  sfsError: null,
  isExpressCallDone: false,
  isShouldShowShippingMethodsInCollapsed: false,
  isNonCachedCartDataCallDone: false,
  triggerCheckoutWithPayment: false,
  isExtendedPreOrderForSpc: false,
  isWalletSetup: false,
  [SPC_SECTION.MY_BAG]: { id: SPC_SECTION.MY_BAG, isExpanded: false, disabled: false },
  [SPC_SECTION.CONTACT]: {
    id: SPC_SECTION.CONTACT,
    isExpanded: false,
    savedContactInfo: {
      emailAddress: '',
      phoneNumber: '',
    },
    smsSignUp: { sendOrderUpdate: false },
    emailSignUp: {},
    isActive: false,
    mobileAsyncContactInfo: {
      emailAddress: '',
      phoneNumber: '',
    },
  },
  [SPC_SECTION.SHIPPING]: {
    id: SPC_SECTION.SHIPPING,
    isExpanded: false,
    mode: SECTION_MODE.SECTION_ADD_MODE,
    disabled: true,
    savedAddress: { ...DEFAULT_ADDRESS },
    autoSuggestMode: ADDRESS_FORM_MODE.AUTO_SUGGEST,
    registeredUserFormMode: REG_FORM_MODE.VIEW_ADDRESSES,
    isFormExpanded: false,
    isMethodAndGiftSectionVisible: false,
    giftServicesDetails: {
      hasGiftWrapping: false,
      optionId: '',
      message: '',
      brand: '',
    },
    shipmentMethods: { shippingMethodId: '' },
    isActive: false,
  },
  [SPC_SECTION.PICKUP]: {
    id: SPC_SECTION.PICKUP,
    isExpanded: false,
    mode: SECTION_MODE.SECTION_ADD_MODE,
    disabled: true,
  },
  [SPC_SECTION.PAYMENT]: {
    id: SPC_SECTION.PAYMENT,
    isPaymentMethodExpanded: false,
    isExpanded: false,
    disabled: true,
    mode: SECTION_MODE.SECTION_ADD_MODE,
    cardDetails: { cardTypeRadio: CARD_TYPES.CREDIT_CARD },
    isFormExpanded: false,
    isActive: false,
  },
  isCvvVisibleOnViewMode: false,
  isClickedOutsideShipping: false,
  cvvModuleXContent: {},
  giftDetailsModalModuleXContent: {},
  giftDetailsGymModalModuleXContent: {},
  giftDetailsSnjModalModuleXContent: {},
  [SPC_BUTTON.SAVE_CONTACT]: false,
  [SPC_BUTTON.SAVE_SHIPPING]: false,
  [SPC_BUTTON.SAVE_PICKUP]: false,
  [SPC_BUTTON.SAVE_PAYMENT]: false,
  [SPC_BUTTON.APPLY_GIFT_CARD]: false,
  [SPC_BUTTON.SUBMIT_ORDER]: false,
  showAddressVerification: false,
  submitOrderButtonState: SUBMIT_ORDER_BUTTON_STATE.NORMAL,
  moveItemToSFLoading: false,
  removeItemInProgress: false,
  showVerifyCvvModal: false,
  suppressCCheck: false,
  shouldShowVerifyCvvModal: false,
};

export default (state = { ...INIT_STATE }, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_SECTION_STATE: {
      const { id, section } = payload;
      return { ...state, [id]: { ...state[id], ...section } };
    }
    case UPDATE_MULTIPLE_SECTION_STATES: {
      return {
        ...state,
        ...payload.reduce(
          (diffState, sectionState) => ({
            ...diffState,
            [sectionState.id]: { ...state[sectionState.id], ...sectionState.section },
          }),
          {}
        ),
      };
    }
    case TOGGLE_SPC: {
      const { isSPC } = payload;
      return { ...state, isSPC };
    }
    case SET_CVV_MODULE_X: {
      return { ...state, ...{ cvvModuleXContent: action.payload } };
    }
    case SET_GIFT_DETAIL_MODAL_MODULE_X: {
      const {
        giftDetailsModalModuleXContent,
        giftDetailsGymModalModuleXContent,
        giftDetailsSnjModalModuleXContent,
        giftDetailsPjpModalModuleXContent,
      } = action.payload || {};
      return {
        ...state,
        ...{
          giftDetailsModalModuleXContent,
          giftDetailsGymModalModuleXContent,
          giftDetailsSnjModalModuleXContent,
          giftDetailsPjpModalModuleXContent,
        },
      };
    }
    case SET_CVV_VISIBILITY_ON_VIEW_MODE: {
      return { ...state, ...{ isCvvVisibleOnViewMode: action.payload } };
    }
    case SET_SPC_BTN_LOADER: {
      const {
        payload: { id, isLoading },
      } = action;
      return { ...state, [id]: isLoading };
    }
    case RESET_SPC_UI_STATE: {
      return { ...INIT_STATE };
    }
    case SET_SECTION_ANCHORING: {
      return {
        ...state,
        [SPC_SECTION.CONTACT]: {
          ...state[SPC_SECTION.CONTACT],
          isActive: payload[SPC_SECTION.CONTACT],
        },
        [SPC_SECTION.SHIPPING]: {
          ...state[SPC_SECTION.SHIPPING],
          isActive: payload[SPC_SECTION.SHIPPING],
        },
        [SPC_SECTION.PICKUP]: {
          ...state[SPC_SECTION.PICKUP],
          isActive: payload[SPC_SECTION.PICKUP],
        },
        [SPC_SECTION.PAYMENT]: {
          ...state[SPC_SECTION.PAYMENT],
          isActive: payload[SPC_SECTION.PAYMENT],
        },
      };
    }
    case SHOW_ADDRESS_VERIFICATION:
      return { ...state, showAddressVerification: action.payload };
    case UPDATE_SUBMIT_ORDER_BUTTON_STATE:
      return { ...state, submitOrderButtonState: action.payload };
    case SET_SFS_ERROR:
      return { ...state, sfsError: action.payload };
    case MOVE_ITEM_TO_SFL_TOGGLE:
      return { ...state, moveItemToSFLoading: action.payload };
    case REMOVE_ITEM_IN_PROGRESS:
      return { ...state, removeItemInProgress: action.payload };
    case CLICKED_OUTSIDE_SHIPPING:
      return {
        ...state,
        ...{ isClickedOutsideShipping: action.payload },
      };
    case IS_EXPRESS_CALL_DONE:
      return {
        ...state,
        ...{ isExpressCallDone: action.payload },
      };
    case IS_NON_CACHED_CART_DATA_CALL_DONE:
      return {
        ...state,
        ...{ isNonCachedCartDataCallDone: action.payload },
      };
    case TRIGGER_CHECKOUT_WITH_PAYMENT:
      return {
        ...state,
        ...{ triggerCheckoutWithPayment: action.payload },
      };
    case IS_EXTENDED_PRE_ORDER:
      return { ...state, isExtendedPreOrderForSpc: action.payload };
    case SET_APPLE_WALLET:
      return { ...state, isWalletSetup: action.payload };
    case SHOW_SHIPPING_METHODS_IN_COLLAPSED:
      return {
        ...state,
        ...{ isShouldShowShippingMethodsInCollapsed: action.payload },
      };
    case TOGGLE_VERIFY_CVV_MODAL:
      return {
        ...state,
        ...{ showVerifyCvvModal: action.payload },
      };
    case SET_SUPPRESS_CCHECK:
      return {
        ...state,
        ...{ suppressCCheck: action.payload },
      };
    case SHOULD_SHOW_VERIFY_CVV_MODAL:
      return {
        ...state,
        ...{ shouldShowVerifyCvvModal: action.payload },
      };
    case SET_IS_OOS_ITEM:
      return {
        ...state,
        ...{ isOosItem: action.payload },
      };

    default:
      return state;
  }
};
